exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".e1uq18c4kemqyqszurtmq7ya41e36sf8thjyt6rz7b99gacp5k24gnw685hn8z5whnpk69e9bhnn4q76tv1n5zke6svxgm491zs1r4-ChipList-module-chips-wrapper{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}", "", {"version":3,"sources":["C:/a/_work/5/s/src/components/ChipList/C:/a/_work/5/s/src/components/ChipList/ChipList.module.scss"],"names":[],"mappings":"AAAA,sIACE,8BAAA,6BAAA,uBAAA,mBACA,mBAAA,cAAe,CAChB","file":"ChipList.module.scss","sourcesContent":[".chips-wrapper {\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"chips-wrapper": "e1uq18c4kemqyqszurtmq7ya41e36sf8thjyt6rz7b99gacp5k24gnw685hn8z5whnpk69e9bhnn4q76tv1n5zke6svxgm491zs1r4-ChipList-module-chips-wrapper"
};